<div
  class="header pb-7 pt-5 pt-lg-7 d-flex align-items-center"
  style="
    min-height: 120px;
    background-size: cover;
    background-position: center top;
  "
>
  <span class="mask bg-gradient-primary opacity-8"></span>
  <div class="container-fluid d-flex align-items-center">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <h1 class="text-white">Cashback</h1>
        <p class="text-white mt-0 mb-5">Lista de compras com cashback</p>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt--7">
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <div class="card shadow">
        <div class="table-responsive">
          <table class="table align-items-center table-flush">
            <thead class="thead-light">
              <tr>
                <th scope="col">Cliente</th>
                <th scope="col">Status</th>
                <th scope="col">Ações</th>
              </tr>
            </thead>
            <tbody>
              <!-- Loading State -->
              <tr *ngIf="loading">
                <td colspan="3" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Carregando...</span>
                  </div>
                  <p class="mt-2 mb-0">Carregando cashbacks...</p>
                </td>
              </tr>

              <!-- Error State -->
              <tr *ngIf="error && !loading">
                <td colspan="3" class="text-center py-4">
                  <div class="alert alert-danger mb-0">
                    <i class="ni ni-notification-70"></i> {{ error }}
                  </div>
                </td>
              </tr>

              <!-- Empty State -->
              <tr *ngIf="(items$ | async)?.length === 0 && !loading && !error">
                <td colspan="3" class="text-center py-4">
                  <div class="alert alert-info mb-0">
                    <i class="ni ni-info-circle"></i> Nenhum cashback
                    encontrado.
                  </div>
                </td>
              </tr>

              <!-- Data Rows -->
              <tr
                *ngFor="let item of items$ | async; trackBy: trackByFn"
                [ngClass]="cashbackService.rowClass(item)"
              >
                <td scope="row">
                  <div class="media align-items-center">
                    <a
                      href="javascript:void(0)"
                      class="avatar rounded-circle mr-3"
                      [style.background-image]="
                        'url(' +
                        (item?.customer?.photoURL ||
                          '/assets/img/default-avatar.png') +
                        ')'
                      "
                      [style.background-size]="'cover'"
                      [style.background-position]="'center'"
                    >
                    </a>
                    <div class="media-body">
                      <strong class="mb-0">
                        {{
                          item?.customer?.nomeCompleto ||
                            "Cliente não encontrado"
                        }}
                      </strong>
                      <br />
                      <small class="text-muted">
                        {{
                          item?.dateTime?.toDate()
                            | date : "dd/MM/yyyy HH:mm:ss"
                        }}
                      </small>
                      <br />
                      <div class="mt-1">
                        <span class="text-sm">
                          <strong>Compra:</strong>
                          {{
                            item.valor | currency : "BRL" : "symbol" : "1.2-2"
                          }}
                        </span>
                        <br />
                        <span class="text-sm">
                          <strong>Cashback:</strong>
                          {{
                            item.cashback
                              | currency : "BRL" : "symbol" : "1.2-2"
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>

                <td>
                  <span
                    class="badge badge-pill"
                    [ngClass]="cashbackService.statusBadgeClass(item)"
                  >
                    <i
                      class="ni"
                      [ngClass]="cashbackService.statusIconClass(item)"
                    ></i>
                    {{ cashbackService.statusLabel(item) }}
                  </span>
                </td>

                <td>
                  <div class="cashback-actions" role="group">
                    <button
                      type="button"
                      (click)="verImagem(item?.imagem)"
                      class="btn btn-sm btn-outline-secondary"
                      title="Ver comprovante"
                      [disabled]="!item?.imagem"
                    >
                      <i class="ni ni-image"></i
                      ><span class="btn-label"> Ver comprovante</span>
                    </button>

                    <button
                      *ngIf="cashbackService.isPendente(item)"
                      type="button"
                      (click)="aprovar(item?.id)"
                      class="btn btn-sm btn-success"
                      title="Aprovar cashback"
                    >
                      <i class="ni ni-check-bold"></i
                      ><span class="btn-label"> Aprovar</span>
                    </button>

                    <button
                      *ngIf="cashbackService.isPendente(item)"
                      type="button"
                      (click)="rejeitar(item?.id)"
                      class="btn btn-sm btn-danger"
                      title="Rejeitar cashback"
                    >
                      <i class="ni ni-fat-remove"></i
                      ><span class="btn-label"> Rejeitar</span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginação -->
        <div
          class="card-footer py-4"
          *ngIf="(items$ | async)?.length && (items$ | async)!.length > 0"
        >
          <nav aria-label="Paginação de cashbacks">
            <ul class="pagination justify-content-end mb-0">
              <li
                class="page-item"
                [class.disabled]="!cashbackService.hasPreviousPage"
              >
                <button
                  class="page-link"
                  type="button"
                  (click)="prevPage()"
                  [disabled]="!cashbackService.hasPreviousPage"
                  title="Página anterior"
                >
                  <i class="fas fa-angle-left"></i>
                  <span class="sr-only">Anterior</span>
                </button>
              </li>
              <li
                class="page-item"
                [class.disabled]="!cashbackService.hasNextPage"
              >
                <button
                  class="page-link"
                  type="button"
                  (click)="nextPage()"
                  [disabled]="!cashbackService.hasNextPage"
                  title="Próxima página"
                >
                  <i class="fas fa-angle-right"></i>
                  <span class="sr-only">Próxima</span>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
